import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * Line icons for the Web Forms screen. The design draws them as inline stroked
 * SVGs rather than Material glyphs, matching Sign Requests.
 *
 * They inherit `currentColor`; size comes from the caller's `sx`.
 */

const strokeProps = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/** Circled plus on the "Create Web Form" button. */
export const PlusCircleGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <circle {...strokeProps} strokeWidth={2.2} cx="12" cy="12" r="9" />
    <path {...strokeProps} strokeWidth={2.2} d="M12 8v8M8 12h8" />
  </SvgIcon>
);

/** Bare plus — the phone reference's floating "Create" pill uses this one. */
export const PlusGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...strokeProps} strokeWidth={2.3} d="M12 5v14M5 12h14" />
  </SvgIcon>
);

/** Form document with two filled lines — the icon tile on every row. */
export const WebFormGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      {...strokeProps}
      strokeWidth={1.8}
      d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"
    />
    <path {...strokeProps} strokeWidth={1.8} d="M14 3v5h5" />
    <path {...strokeProps} strokeWidth={1.8} d="M9 13h6M9 17h4" />
  </SvgIcon>
);

/** Vertical three-dot overflow trigger — filled, not stroked. */
export const KebabGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="5" r="1.6" fill="currentColor" />
    <circle cx="12" cy="12" r="1.6" fill="currentColor" />
    <circle cx="12" cy="19" r="1.6" fill="currentColor" />
  </SvgIcon>
);

/** Points at the rows still to come, in the card's load-more footer. */
export const ChevronDownGlyph = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path {...strokeProps} strokeWidth={2} d="m6 9 6 6 6-6" />
  </SvgIcon>
);
